<div class="save-as-batch-container">
  <div fxLayout="row">
    <div fxFlex="94" class="outer-align">
      <div fxLayout="row" class="row-container dialog_herder"></div>
      <div fxFlex="91" class="center_data">
        <h2 mat-dialog-title>
          {{ shouldDisplayOrders ? 'Order Details' : 'Batch orders before printing labels' }}
        </h2>
      </div>
      <div fxFlex="9" class="align-right">
        <h2 class="dialog-close">
          <img (click)="closebtn()" src="../../../../assets/icons/cancel.svg" />
        </h2>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="print-details__newui">
    @if (!shouldDisplayOrders) {
      <div class="batch-details-container__newui">
        <!-- <div fxFlex="70" class="outer-align"> -->
        <div class="batch-details">
          <div class="batch-detail__key">No. of orders:</div>
          <div class="batch-detail__value">{{ data.ids.length }}</div>
        </div>
        <div class="batch-details">
          <div class="batch-detail__key">Delivery service:</div>
          <div class="batch-detail__value">
            {{ getBatchCarrierValue() }}
          </div>
        </div>
        @if (data?.batch?.rateInfo?.totalPrice) {
          <div class="batch-details">
            <div class="batch-detail__key">Price:</div>
            <div class="batch-detail__value">{{ currencySign }}{{ data.batch.rateInfo.totalPrice }}</div>
          </div>
        }
        <div class="batch-details">
          <div class="batch-detail__key">Batch name:</div>
          <div class="batch-detail__value">
            {{ data.batch.name }}
            @if (data?.batch?.rateInfo) {
              <img
                src="/assets/images/print/plus_icon.svg"
                class="view-orders-button__newui"
                matTooltip="View Orders Details"
                (click)="onViewOrdersClicked()" />
            }
          </div>
        </div>
      </div>
    } @else {
      <button class="back-button" flex="10" mat-button (click)="onBackClickced()">
        <mat-icon>keyboard_backspace</mat-icon>
        BACK
      </button>
      <section class="view-labels-container">
        <div class="view-labels-content" mat-dialog-content>
          <table class="table" cdk-table [dataSource]="data?.batch?.rateInfo?.ordersRatesDetails">
            <ng-container cdkColumnDef="CarrierName">
              <th style="padding-left: 25px" cdk-header-cell *cdkHeaderCellDef>Carrier Name</th>
              <td style="padding-left: 25px" cdk-cell *cdkCellDef="let orderRateDetails">
                {{ data?.batch?.rateInfo?.provider + ': ' + orderRateDetails?.serviceLevelName }}
              </td>
            </ng-container>
            <ng-container cdkColumnDef="OrderNumber">
              <th cdk-header-cell *cdkHeaderCellDef>Order Number</th>
              <td cdk-cell *cdkCellDef="let orderRateDetails">
                {{ orderRateDetails?.orderNumber }}
              </td>
            </ng-container>
            <ng-container cdkColumnDef="Amount">
              <th cdk-header-cell *cdkHeaderCellDef>Price</th>
              <td cdk-cell *cdkCellDef="let orderRateDetails">
                <span> ${{ orderRateDetails?.price }} </span>
              </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
            <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </section>
    }
    <div class="button-holder edit-batch-name-container__newui">
      <div class="edit-batch-name-button edit-batch-name__newui" (click)="toggleBatchNameEdit()" matRipple>
        @if (showBatchNameEdit) {
          <input #batchNameEditInput class="edit-batch-name-input" maxlength="15" [(ngModel)]="batchNameInput" />
        }
        <div class="edit-batch-name__newui__text">
          {{ editBatchNameButtonText }}
        </div>
      </div>
      <!-- <button
      mat-flat-button
      class="edit-batch-name-button"
      (click)="toggleBatchNameEdit()"
      >
      {{ editBatchNameButtonText }}
      <mat-icon>{{ editBatchNameButtonIcon }}</mat-icon>
    </button> -->
    </div>
    <!-- </div> -->

    <div fxLayout="row">
      <div fxFlex="38" class="outer-align center_data">
        <button
          [disabled]="confirming"
          class="confirmbutton confirmbutton__newui global_hover_button"
          (click)="confirm()">
          {{ pickConfirmButtonText(data) }}
        </button>
      </div>
    </div>
  </div>
</div>
